module.exports = __webpack_public_path__ + "static/media/MultipleUses.3d239a9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ipd503/MultipleUses.png
// module id = 176
// module chunks = 0